import { fetch } from '@atlassian/eoc-fetch';
import { UrlHelper } from '../../../common/utils/url-helper';
const getIntegrationList = (query, teamId) => {
  const {
    keyword,
    group
  } = query !== null && query !== void 0 ? query : {};
  return fetch(UrlHelper(`/v3/integrations/unified/supported-integrations`, {
    keyword,
    group,
    teamId
  })).then(response => {
    const {
      labels,
      availableGroups,
      allTypes,
      platformTeamId
    } = response.data;
    return {
      labels,
      availableGroups,
      allTypes,
      platformTeamId
    };
  });
};
const getIntegrationTypes = (integrationType, teamId) => fetch(UrlHelper(`/v3/integrations/unified/${integrationType}/types`, {
  teamId
})).then(response => response.data.map(integrationType => ({
  ...integrationType,
  value: integrationType.type,
  label: integrationType.displayName
})));
export default {
  getIntegrationList,
  getIntegrationTypes
};